var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2874 18.0485L14.2711 13.0322C15.3567 11.7033 15.9557 10.0299 15.9557 8.20312C15.9557 3.90185 12.4694 0.416664 8.16924 0.416664C3.86909 0.416664 0.416466 3.90298 0.416466 8.20312C0.416466 12.5033 3.90241 15.9896 8.16924 15.9896C9.99569 15.9896 11.6713 15.3566 12.9983 14.3035L18.0146 19.3198C18.2243 19.4972 18.4564 19.5833 18.6847 19.5833C18.9131 19.5833 19.1444 19.4956 19.32 19.3201C19.6692 18.9694 19.6692 18.4004 19.2874 18.0485ZM2.21335 8.20312C2.21335 4.90062 4.90043 2.21354 8.20293 2.21354C11.5054 2.21354 14.1925 4.90062 14.1925 8.20312C14.1925 11.5056 11.5054 14.1927 8.20293 14.1927C4.90043 14.1927 2.21335 11.5049 2.21335 8.20312Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.8223c0235b33069305f6cb5e2fcc5fc3.svg";
export { ForwardRef as ReactComponent };